{
  "fabric": {
    "nightly": {
      "react-native": ["0.86", "0.87", "0.88"],
      "react-native-worklets": ["nightly"]
    },
    "4.7.x": {
      "react-native": ["0.86", "0.87", "0.88"],
      "react-native-worklets": ["0.13.x"]
    },
    "4.6.x": {
      "react-native": ["0.83", "0.84", "0.85", "0.86", "0.87"],
      "react-native-worklets": ["0.12.x"]
    },
    "4.5.x": {
      "react-native": ["0.83", "0.84", "0.85", "0.86"],
      "react-native-worklets": ["0.10.x", "0.11.x"]
    },
    "4.4.x": {
      "react-native": ["0.83", "0.84", "0.85", "0.86"],
      "react-native-worklets": ["0.9.x", "0.10.x"]
    },
    "4.3.x": {
      "react-native": ["0.81", "0.82", "0.83", "0.84", "0.85"],
      "react-native-worklets": ["0.8.x"]
    },
    "4.2.x": {
      "react-native": ["0.80", "0.81", "0.82", "0.83", "0.84"],
      "react-native-worklets": ["0.7.x", "0.8.x"]
    },
    "4.1.x": {
      "react-native": ["0.78", "0.79", "0.80", "0.81", "0.82"],
      "react-native-worklets": ["0.5.x", "0.6.x", "0.7.x", "0.8.x"]
    },
    "4.0.x": {
      "react-native": ["0.78", "0.79", "0.80", "0.81"],
      "react-native-worklets": ["0.4.x"]
    },
    "3.19.x": {
      "react-native": ["0.78", "0.79", "0.80", "0.81"]
    },
    "3.18.x": {
      "react-native": ["0.75", "0.76", "0.77", "0.78", "0.79", "0.80"]
    },
    "3.17.x": {
      "react-native": ["0.75", "0.76", "0.77", "0.78", "0.79"]
    },
    "3.16.x": {
      "react-native": ["0.74", "0.75", "0.76", "0.77"]
    },
    "3.15.x": {
      "react-native": ["0.74", "0.75"]
    },
    "3.9.x - 3.14.x": {
      "react-native": ["0.74"]
    },
    "3.6.x - 3.8.x": {
      "react-native": ["0.72", "0.73"]
    },
    "3.1.x - 3.5.x": {
      "react-native": ["0.72"]
    },
    "3.0.x": {
      "react-native": ["0.71"]
    }
  },
  "paper": {
    "3.19.x": {
      "react-native": ["0.78", "0.79", "0.80", "0.81"]
    },
    "3.18.x": {
      "react-native": ["0.75", "0.76", "0.77", "0.78", "0.79", "0.80"]
    },
    "3.17.x": {
      "react-native": ["0.75", "0.76", "0.77", "0.78", "0.79"]
    },
    "3.16.x": {
      "react-native": ["0.74", "0.75", "0.76", "0.77"]
    },
    "3.15.x": {
      "react-native": ["0.72", "0.73", "0.74", "0.75"]
    },
    "3.9.x - 3.14.x": {
      "react-native": ["0.71", "0.72", "0.73", "0.74"]
    },
    "3.6.x - 3.8.x": {
      "react-native": [
        "0.66",
        "0.67",
        "0.68",
        "0.69",
        "0.70",
        "0.71",
        "0.72",
        "0.73"
      ]
    },
    "3.5.x": {
      "react-native": ["0.66", "0.67", "0.68", "0.69", "0.70", "0.71", "0.72"]
    },
    "3.3.x - 3.4.x": {
      "react-native": [
        "0.63",
        "0.64",
        "0.65",
        "0.66",
        "0.67",
        "0.68",
        "0.69",
        "0.70",
        "0.71",
        "0.72"
      ]
    },
    "3.0.x - 3.2.x": {
      "react-native": [
        "0.63",
        "0.64",
        "0.65",
        "0.66",
        "0.67",
        "0.68",
        "0.69",
        "0.70",
        "0.71"
      ]
    },
    "2.14.x - 2.17.x": {
      "react-native": [
        "0.63",
        "0.64",
        "0.65",
        "0.66",
        "0.67",
        "0.68",
        "0.69",
        "0.70",
        "0.71"
      ]
    },
    "2.11.x - 2.13.x": {
      "react-native": [
        "0.63",
        "0.64",
        "0.65",
        "0.66",
        "0.67",
        "0.68",
        "0.69",
        "0.70"
      ]
    },
    "2.10.x": {
      "react-native": ["0.63", "0.64", "0.65", "0.66", "0.67", "0.68", "0.69"]
    },
    "2.5.x - 2.9.x": {
      "react-native": ["0.63", "0.64", "0.65", "0.66", "0.67", "0.68"]
    },
    "2.3.x - 2.4.x": {
      "react-native": ["0.63", "0.64", "0.65", "0.66", "0.67"]
    }
  }
}
